// extracted by mini-css-extract-plugin
export var card = "LegalPrivacyTable-module--card--74efd";
export var cardSection = "LegalPrivacyTable-module--cardSection--50905";
export var desktopTable = "LegalPrivacyTable-module--desktopTable--bfd58";
export var label = "LegalPrivacyTable-module--label--7810f";
export var mobileCards = "LegalPrivacyTable-module--mobileCards--59d28";
export var value = "LegalPrivacyTable-module--value--bc07b";
export var wrapper = "LegalPrivacyTable-module--wrapper--36f36";